import { ImageSizes } from '@/components/parts/catalog/list';

export const ACTION_FETCH = 'fetch';
export const BREADCRUMBS_TEXT = 'Организации';
export const BY_PAGE_TEXT = 'Организаций на странице';
export const IMG_BG_COLOR = '#ffffff';
export const IMG_BG_SIZE = ImageSizes.CONTAIN;
export const PAGE_NUMBER = 1;
export const PAGE_TITLE = 'Каталог организаций';
export const PAGE_SEO_TITLE = PAGE_TITLE;
export const PAGE_SIZE = 19;
export const PAGE_SIZES = [7, 19, 39];
export const SITEMAP_TEXT =
  'Попробуйте воспользоваться формой слева используя менее узкие критерии подбора учреждения.';
export const SITEMAP_TITLE =
  'К сожалению, нам не удалось найти ничего подходящего.';
export const STORE_MODULE_NAME = 'organizations';

export * from '../const';



// WEBPACK FOOTER //
// ./src/pages/organizations/list/const.ts